import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import withWidth, { isWidthDown } from '@material-ui/core/withWidth';
import classNames from 'classnames';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import LinearProgress from '@material-ui/core/LinearProgress';
import Typography from '@material-ui/core/Typography';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';
import TableRow from '@material-ui/core/TableRow';
import TablePagination from '@material-ui/core/TablePagination';
import Checkbox from '@material-ui/core/Checkbox';
import NumberFormat from 'react-number-format';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';

import EnhancedTableToolbar from './EnhancedTableToolbar';
import EnhancedTableHead from './EnhancedTableHead';
import CurrencyInputFormat from './CurrencyInputFormat';
import DatePicker from 'react-datepicker'
import "react-datepicker/dist/react-datepicker.css";

import { fetchInvoices, toggleInvoice, 
    toggleAllInvoices, changePaymentAmount,resetCheckPaymentAmount,getTotalInvoiceAmount } from './actions/invoice';
import { fetchCredit, toggleCredit, toggleAllCredit, changeCreditAdhocAmount } from './actions/credit';

const styles = theme => ({
    root: {
        display: 'flex',
        flexWrap: 'wrap',
        flexDirection: 'column',
        position: 'relative',
        margin:6,
        padding:6, 
        width: '100%'
    },
    disabled: {
        pointerEvents: 'none',
        opacity: 0.5,
        filter: 'grayscale(0.5)',
    },
    table: {
        // minWidth: 1020,
    },
    tableWrapper: {
        overflowX: 'auto',
        padding: 0
    },
    linearProgress: {
        position: 'absolute',
        width: '100%',
    },
    paginationToolbar: {
        [theme.breakpoints.down('sm')]: {
            paddingLeft: 2,
        }
    },
    paginationActions: {
        [theme.breakpoints.down('sm')]: {
            marginLeft: 4,
        }
    },
    currencyInput: {
        padding: '0 4px',
        width: 96,
        [theme.breakpoints.up('sm')]: {
            padding: '0 8px',
            width: 150,
        }
    },
    label:{    
      paddingLeft:'15px'
    }
});
const months = {
    Jan: '01',
    Feb: '02',
    Mar: '03',
    Apr: '04',
    May: '05',
    Jun: '06',
    Jul: '07',
    Aug: '08',
    Sep: '09',
    Oct: '10',
    Nov: '11',
    Dec: '12',
  }

class EnhancedTable extends Component {

    constructor(props) {
        super(props);
        //let currencylist = props.customer.availableCurrencies.filter(list => list === props.customer.currencyCode);
        let currencies = props.customer.availableCurrencies.map((currency, index) => {
              return {
                name: currency,
                selected: currency === props.customer.currencyCode
              }
        });
        let columns = invoiceColumns;
        if (isWidthDown('sm', this.props.width)) {
            columns = columns.map(column => {
                return { ...column, display: column.mobileDisplay }
            })
        }
        this.state = {
            currencies,
            columns,
            order: 'asc',
            orderBy: 'invoiceDueDate',
            orderByArray:['invoiceDueDate'],
            dueDateMonthFilter:"",
            dueDateYearFilter:"",
            page: 0,
            rowsPerPage: 5,
            textFieldDisable:false
        };

        this.props.fetchInvoices(currencies.find(currency => currency.selected).name);
    }

    redirectToInvoice(e,invoice,column){
        //console.log(invoice[column.id]);
        e.preventDefault();
        e.stopPropagation()
        let redirectURL = '/invoice-info/'+invoice[column.id];
        let win = window.open(redirectURL, '_blank');
        win.focus();
    }

    handleChange (m) {
        this.setState({selectedMonth:m}, () => {
         this.onRequestFilter(m);
        });
    }

    componentWillReceiveProps(nextProps) {
        // if (nextProps.startTime !== this.state.startTime) {
        //     this.setState({ startTime: nextProps.startTime });
        // }
        let totalInvoiceAmount = nextProps.invoices.reduce((accumulator, invoice) => accumulator + (+invoice.netAmount), 0); 
        this.props.getTotalInvoiceAmount(totalInvoiceAmount)
    }

    toggleColumns = option => {      
        this.setState(prevState => {            
            let columns = prevState.columns.map(value => {
                if (value === option) {
                    value.display = !option.display;
                }
                return value;
            });
            return { columns }
        })
    }

    toggleCurrency = value => {
        this.setState(prevState => {            
            let currencies = prevState.currencies.map((currency, index) => {
                return {
                    name: currency.name,
                    selected: value === index
                }
            });
            this.props.fetchInvoices(currencies.find(currency => currency.selected).name);
            this.props.fetchCredit(currencies.find(currency => currency.selected).name);
            return { currencies }
        })
    }

    handleRequestSort = (event, property) => {
       const orderBy = property;
        let order = this.state.order;
        if (this.state.orderByArray.includes(property)) {
            if(this.state.order === 'asc')
                order = 'desc';
            if(this.state.order === 'desc')
                order = 'asc';

           let orderingArr = this.state.orderByArray.splice(0, this.state.orderByArray.length); 
           this.setState({orderByArray:[]});   

        }
        if(!this.state.orderByArray.includes(property)){
        this.state.orderByArray.push(property);
       }
        this.setState({ order, orderBy,orderByArray:this.state.orderByArray});
    };

    onRequestFilter=(m)=>{
         //console.log(m);
         this.unCheckedToggleAllInvoice(false,this.props.invoices);
         if(m !== null && m !== ""){
            let selectedDate = m.toString().split(" ");
            let selectedMonth = months[selectedDate[1]];
            let selectedYear = selectedDate[3];
            //console.log(selectedMonth+"=="+selectedYear);
            this.setState({dueDateMonthFilter:selectedMonth, dueDateYearFilter:selectedYear});
         }else{
            this.setState({dueDateMonthFilter:'', dueDateYearFilter:''});
         }
    };

    handleChangePage = (event, page) => {
        this.setState({ page });
    };

    handleChangeRowsPerPage = event => {
        this.setState({ rowsPerPage: event.target.value });
    };

    handlePaymentAmountInput = (event, invoice) => {
        this.props.changePaymentAmount(invoice.entryNo, event.target.value);
    };

    handlePaymentAmountInputValidation = (invoice) => {
        if (this.props.paymentAmounts[invoice.entryNo] > invoice.netAmount || this.props.paymentAmounts[invoice.entryNo] <= 0) {
            this.props.changePaymentAmount(invoice.entryNo, invoice.netAmount);
        }
    };

    checkedToggleInvoice = (invoice) => {        
        this.props.toggleInvoice(invoice.entryNo);
        if(!invoice.selected){
            this.props.changePaymentAmount(invoice.entryNo, invoice.netAmount); 
        }
    }

    checkedToggleAllInvoice = (checked,invoices) => { 
        this.props.toggleAllInvoices(checked,invoices);
        if(!checked){
           this.props.fetchInvoices(this.state.currencies.find(currency => currency.selected).name);
           //if(this.state.dueDateMonthFilter === "")
           //this.props.resetCheckPaymentAmount(invoices)
        }
    }

    unCheckedToggleAllInvoice = (checked,invoices) => {  
        this.props.toggleAllInvoices(checked,invoices);
        if(!checked){
           this.props.fetchInvoices(this.state.currencies.find(currency => currency.selected).name);
        }
    }
    
    getTableRow = (invoice,index) => {
        const columnsToBeDisplayed = this.state.columns.filter(column => column.display);
        const { paymentAmounts } = this.props;
        let tableCells = columnsToBeDisplayed.map(column => { 
           if (column.id === 'paymentAmount') {
               return (
                    <TableCell key="paymentAmount" padding="none" numeric={column.numeric}>
                        <TextField
                            value={ invoice.selected ? paymentAmounts[invoice.entryNo]:""}                                                     
                            disabled={!invoice.selected}
                            onChange={event => this.handlePaymentAmountInput(event, invoice)}
                            onBlur={event => this.handlePaymentAmountInputValidation(invoice)}
                            //classes={{root: this.props.classes.currencyInput}}
                            InputProps={{
                                inputComponent: CurrencyInputFormat,
                            }}
                            inputProps={{
                                currencyCode:this.props.customer.currencyCode,
                            }}
                            onClick={ invoice.selected ? (event) => event.stopPropagation(): undefined }
                        />
                    </TableCell>
                )
            }
            return (
                <TableCell key={column.id} padding="none" numeric={column.numeric}>
                    { column.name.indexOf ('Invoice Number') !== -1 ? (
                        <span style={{color:'#fa451c',cursor:'pointer',WebkitTextFillColor:'#fa451c'}} onClick={(e)=>this.redirectToInvoice(e, invoice,column)}>
                          {invoice[column.id]}
                        </span>
                    ) : column.name.indexOf('Install') !== -1 ? (
                         (invoice["paymentTermsCoder"].indexOf('INST') !== -1) ? (
                            invoice[column.id]+"/"+invoice["paymentTermsCoder"].split('-')[1]
                            ):(invoice[column.id] === "0") ? "1/1":(invoice[column.id])
                    ) : column.name.indexOf('Amount') === -1 ? (
                        invoice[column.id]
                    ) : (
                            <NumberFormat value={invoice[column.id]}
                                fixedDecimalScale={true}
                                decimalScale={2}
                                displayType={'text'} thousandSeparator={true} prefix={this.props.customer.currencyCode === 'CAD'?'CAD ':'$'} />
                        )}
                </TableCell>
            )
        })

        return (
            <TableRow
                hover
                role="checkbox"
                aria-checked={false}
                tabIndex={-1}
                key={index}
                selected={invoice.selected}
                onClick={event => this.checkedToggleInvoice(invoice)}
                className={classNames({
                    [this.props.classes.disabled]: this.props.adhocPaymentEnabled,
                })}
            >
                <TableCell padding="none">
                    <Checkbox checked={invoice.selected} />
                </TableCell>
                {tableCells}
            </TableRow>
        )
    }   

    getDueDateFilter(invoiceRecords){
      if(this.state.dueDateMonthFilter !== "" && this.state.dueDateYearFilter !== ""){
        let dueDateMonthFilterStart = this.state.dueDateMonthFilter+"/"+"1"+"/"+this.state.dueDateYearFilter;
        let dueDateMonthFilterEnd = this.state.dueDateMonthFilter+"/"+"31"+"/"+this.state.dueDateYearFilter;
        return ((new Date(invoiceRecords['invoiceDueDate']) >= new Date(dueDateMonthFilterStart)) && (new Date(invoiceRecords['invoiceDueDate']) <= new Date(dueDateMonthFilterEnd)));
      }
    }

    getSorting(order, orderBy) {
       return(order === 'desc'
        ? (a, b) => {
                if(orderBy === 'netAmount' || orderBy === 'paymentAmount' || orderBy === 'invoiceAmount' || orderBy === 'discountAmount' || orderBy === 'discountAvailable' || orderBy === 'installments'){
                    return ((parseFloat(b[orderBy]) < parseFloat(a[orderBy])) ? -1 : 1)
    
                }else if(orderBy === 'invoiceDueDate' || orderBy === 'invoiceDate'){
                   return ((new Date(b[orderBy]) < new Date(a[orderBy])) ? -1 : 1)
    
                }else if(orderBy === 'invoiceNumber' || orderBy === 'saleorderNumber'){
                    return (b[orderBy] < a[orderBy] ? -1 : 1)
     
                 }else{
                    return (b[orderBy] < a[orderBy] ? -1 : 1)
                }
         }
        : (a, b) => {
             if(orderBy === 'netAmount' || orderBy === 'paymentAmount' || orderBy === 'invoiceAmount' || orderBy === 'discountAmount' || orderBy === 'discountAvailable' || orderBy === 'installments'){
                    return ((parseFloat(a[orderBy]) < parseFloat(b[orderBy])) ? -1 : 1)
    
                }else if(orderBy === 'invoiceDueDate' || orderBy === 'invoiceDate'){
                   return ((new Date(a[orderBy]) < new Date(b[orderBy])) ? -1 : 1)
    
                }else if(orderBy === 'invoiceNumber' || orderBy === 'saleorderNumber'){
                    return (a[orderBy] < b[orderBy] ? -1 : 1)
     
                 }else{
                    return (a[orderBy] < b[orderBy] ? -1 : 1)
                }
         
            }
            )

     }

    render() {
        const { classes, fetchingInvoices, invoices,paymentAmounts } = this.props;
        const { currencies, columns, order, orderBy, page, rowsPerPage,orderByArray } = this.state;
        const columnsToBeDisplayed = columns.filter(column => column.display);
        const selectedInvoices = invoices.filter(invoice => invoice.selected);
        let renderingInvoices = invoices;
        if(this.state.dueDateMonthFilter !== "" && this .state.dueDateYearFilter !== ""){
            const filteredInvoice = invoices.filter(invoice => this.getDueDateFilter(invoice));
            renderingInvoices = filteredInvoice;
        }
        const totalAccountBalance = invoices.reduce((accumulator, invoice) => accumulator + (+invoice.netAmount), 0);    
        const totalInvoiceAmount = invoices.filter(invoice => invoice.selected).reduce((accumulator,invoice) => {
                 return accumulator + (+paymentAmounts[invoice.entryNo])
        },0);    
           
        return (
            <Paper className={classes.root}>
                {fetchingInvoices && <LinearProgress color="secondary" className={classes.linearProgress} />}
                <div className={classNames({
                    [classes.disabled]: fetchingInvoices,
                })}>
                    <EnhancedTableToolbar numSelected={selectedInvoices.length}
                        columns={columns} toggleColumns={this.toggleColumns}
                        currencies={currencies} toggleCurrency={this.toggleCurrency}
                        unselectAll={(event) => 
                            this.unCheckedToggleAllInvoice(false,renderingInvoices)}
                        adhocPaymentEnabled={this.props.adhocPaymentEnabled}
                    />
                    <div style={{width:'100%'}}><label style={{fontSize:'15px',fontWeight:'500'}}>Filter by Invoice Due Month:</label><span style={{position:"absolute",zIndex:"10"}}>
                    <DatePicker
                    selected={this.state.selectedMonth}
                    onChange={(date) => this.handleChange(date)}
                    dateFormat="MMMM yyyy"
                    showMonthYearPicker
                    isClearable
                    placeholderText="Select Month"
                />
                    </span></div>
                    <div className={classes.tableWrapper}>
                        <Table className={`${classes.table} openInvoiceInfo`} aria-labelledby="tableTitle">
                            <EnhancedTableHead
                                numSelected={selectedInvoices.length}
                                columns={columnsToBeDisplayed}
                                order={order}
                                orderBy={orderBy}
                                orderByArray={orderByArray}
                                onSelectAllClick={(event, checked) => this.checkedToggleAllInvoice(checked,renderingInvoices)}
                                onRequestSort={this.handleRequestSort}
                                onRequestFilter = {this.onRequestFilter}
                                rowCount={renderingInvoices.length}
                                adhocPaymentEnabled={this.props.adhocPaymentEnabled}
                            />
                            <TableBody>
                                {renderingInvoices
                                    .sort(this.getSorting(order, orderBy))
                                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                    .map(this.getTableRow)}
                                {renderingInvoices.length === 0 && <TableRow style={{ height: 49 * 3 }}>
                                    <TableCell colSpan={columns.length + 1}>
                                        <Typography variant="body2" align="center" gutterBottom>
                                            {fetchingInvoices ? 'Finding open invoices, please wait...' : 'No open invoices at the moment'}
                                        </Typography>
                                    </TableCell>
                                </TableRow>}
                            </TableBody>
                        </Table>
                    </div>
                </div>
                <TablePagination
                    classes={{toolbar: classes.paginationToolbar, actions: classes.paginationActions}}
                    component="div"
                    count={renderingInvoices.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    backIconButtonProps={{
                        'aria-label': 'Previous Page',
                    }}
                    nextIconButtonProps={{
                        'aria-label': 'Next Page',
                    }}
                    onChangePage={this.handleChangePage}
                    onChangeRowsPerPage={this.handleChangeRowsPerPage}
                />
             <Grid container spacing={8} justify="space-around">                       
                        <Grid style={{paddingLeft:'15px'}} item xs={6}>
                        {totalAccountBalance > 0 && <Typography variant="subheading" align="left">
                    <NumberFormat value={totalAccountBalance}
                        fixedDecimalScale={true}
                        decimalScale={2}
                        displayType={'text'} thousandSeparator={true} prefix={this.props.customer.currencyCode === 'CAD'?'Total Account Balance: CAD ':'Total Account Balance: $'}
                    />
                </Typography>}
                        </Grid>                        
                        <Grid style={{paddingRight:'15px'}} item xs={6}>
                        {totalInvoiceAmount > 0 && <Typography variant="subheading" align="right">
                    <NumberFormat value={totalInvoiceAmount}
                    fixedDecimalScale={true} decimalScale={2}
                    displayType={'text'} thousandSeparator={true} prefix={this.props.customer.currencyCode === 'CAD'?'Selected Invoice Amount: CAD ':'Selected Invoice Amount: $'}
                    />
                    </Typography>
                }
                        </Grid>
                    </Grid>
            </Paper>
        );
    }
}

EnhancedTable.propTypes = {
    classes: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
    customer: state.auth.customer,
    fetchingInvoices: state.invoice.fetching,
    invoices: state.invoice.invoices,
    paymentAmounts: state.invoice.paymentAmounts,
    adhocPaymentEnabled: state.invoice.adhocPaymentEnabled
})

const mapDispatchToProps = dispatch => bindActionCreators({
    fetchInvoices,
    toggleAllInvoices,
    toggleInvoice,
    changePaymentAmount,
    fetchCredit,
    resetCheckPaymentAmount,
    getTotalInvoiceAmount
}, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(withWidth()(withStyles(styles)(EnhancedTable)));


const invoiceColumns = [
    {
        id: 'invoiceNumber',
        name: 'Invoice Number',
        display: true,
        mobileDisplay: true,
        disabled: true,
        numeric: false,
        sorting:true,
    },
    {
        id: 'saleorderNumber',
        name: 'Sale Order Number',
        display: true,
        mobileDisplay: true,
        disabled: false,
        numeric: false,
        sorting:true,
    },
    {
        id: 'externalDocumentNumber',
        name: 'Purchase Order',
        display: true,
        mobileDisplay: false,
        disabled: false,
        numeric: false,
        sorting:false,
    },
    {
        id: 'invoiceDate',
        name: 'Invoice Date',
        display: true,
        mobileDisplay: false,
        disabled: false,
        numeric: false,
        sorting:true,
    },
    {
        id: 'invoiceDueDate',
        name: 'Invoice Due Date',
        display: true,
        mobileDisplay: false,
        disabled: false,
        numeric: false,
        sorting:true,
    },
    {
        id: 'invoiceAmount',
        name: 'Invoice Amount',
        display: true,
        mobileDisplay: false,
        disabled: false,
        numeric: true,
        sorting:true,
    },
    {
        id: 'installments',
        name: 'Install/Total Install',
        display: true,
        mobileDisplay: true,
        disabled: false,
        numeric: true,
        sorting:false,
    },
    {
        id: 'discountAvailable',
        name: 'Discount',
        display: true,
        mobileDisplay: false,
        disabled: false,
        numeric: true,
        sorting:false,
    },
    {
        id: 'discountAmount',
        name: 'Discount Amount',
        display: true,
        mobileDisplay: false,
        disabled: false,
        numeric: true,
        sorting:false,
    },
    {
        id: 'netAmount',
        name: 'Net Amount Due',
        display: true,
        mobileDisplay: true,
        disabled: false,
        numeric: true,
        sorting:false,
    },
    // {
    //     id: 'ccCharge',
    //     name: 'Credit Card Charge',
    //     display: true,
    //     mobileDisplay: true,
    //     disabled: true,
    //     numeric: true
    // },
    {
        id: 'paymentAmount',
        name: 'Payment Amount',
        display: true,
        mobileDisplay: true,
        disabled: true,
        numeric: true,
        sorting:false,
    }
];


// WEBPACK FOOTER //
// ./src/EnhancedTable.js